import React, { useState } from 'react';
import {
    Panel,
    IPanelStyles,
    PanelType,
} from '@fluentui/react';
import ButtonPrimaryRoundedComponent from '../button-primary-rounded/button-primary-rounded.component';
import moment from 'moment';
import { Buffer } from "buffer";
import LoaderComponent from '../loader/loader.component';
import ErrorMessageComponent from '../error-message/error-message.component';

import useAuthStatus from '../../hooks/auth/AuthHook';
import ApiService from '../../services/api/api.service';

import ItemTarea from '../../models/ItemTarea';
import ItemDocumento from '../../models/ItemDocumento';

import adjuntoIcon from '../../assets/img32/adjunto_32.png';

const panelStyles : IPanelStyles = {
    root: {},
    overlay: {},
    hiddenPanel: {},
    main: {},
    commands: {
        marginTop: 0,
    },
    contentInner: {},
    scrollableContent: {},
    navigation: {
        backgroundColor: 'var(--color-primario)',
        padding: 10,
        alignItems: 'center',
    },
    header: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 5,
        paddingBottom: 5,
    },
    headerText: {
        color: '#ffffff',
    },
    content: {
        padding: 0,
    },
    footer: {},
    footerInner: {},
    subComponentStyles: {
        closeButton: {
            root: {
                color: '#ffffff',
                backgroundColor: 'transparent',
                padding: 0,
            },
            rootHovered: {
                backgroundColor: '#000000',
                color: '#ffffff',
                borderColor: '#000000',
            },
        },
    },
};

const getFileSize = (base64: string) : number => {
    const buffer : Buffer = Buffer.from(base64.substring(base64.indexOf(',') + 1));
    return (buffer.length / 1e+6);
};

interface IWorkDocumentListComponentProps {
    work: ItemTarea;
    workDocuments: ItemDocumento[];
    onClose: () => void;
    onWorkDocumentCreate: () => void;
    onWorkDocumentDeleted: () => void;
    workDocumentCreateOpen: boolean;
};

const WorkDocumentListComponent = (props: IWorkDocumentListComponentProps) => {
    const auth = useAuthStatus();

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    const onWorkDocumentDelete = (workDocument: ItemDocumento) : void => {
        if (auth.user) {
            if (window.confirm(`¿Confirma que desea eliminar el documento?`)) {
                setLoading(true);
                ApiService.Post<void>(`OrdenesTrabajo`, `DeleteDocumentoAdjunto`, auth.user, {
                    "IdAuto": workDocument.IdAuto,
                }).then(() => {
                    if (props.onWorkDocumentDeleted) {
                        props.onWorkDocumentDeleted();
                    }
                    setLoading(false);
                }, (error: string) => {
                    setError(error);
                    setLoading(false);
                });
            }
        }
    };

    return (
        <Panel
            isOpen={true}
            headerText="Adjuntos"
            onDismiss={props.onClose}
            styles={panelStyles}
            type={PanelType.medium}
            isBlocking={!props.workDocumentCreateOpen}>
            <div className="container-fluid p-0">
                <div className='row m-0'>
                    {
                        props.workDocuments.map((workDocument: ItemDocumento, index: number) => (
                            <div
                                key={index} 
                                className='col-12'>
                                <div className="row py-3 m-0 align-items-center">
                                    <div className='col px-0 row m-0 align-items-center'>
                                        <div className='col-auto'>
                                            <img src={adjuntoIcon} alt="Adjunto" className="img-fluid" />
                                        </div>
                                        <div className='col'>
                                            <p className='m-0'>
                                                {moment(workDocument.fecDoc, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm')}
                                            </p>
                                            <p 
                                                className='m-0'
                                                style={{
                                                    color: '#A0A0A0',
                                                }}>
                                                {workDocument.Descripcion}
                                            </p>
                                        </div>
                                        <div className='col-auto'>
                                            {getFileSize(workDocument.Imagen).toFixed(2)} Mb
                                        </div>
                                    </div>
                                    <div className='col-auto px-0'>
                                        <ButtonPrimaryRoundedComponent
                                            icon='ChromeClose'
                                            onClick={() => onWorkDocumentDelete(workDocument)} />
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    <div className="col-12 py-2 justify-content-end d-flex">
                        <ButtonPrimaryRoundedComponent
                            icon="add"
                            onClick={props.onWorkDocumentCreate} />
                    </div>
                </div>
                <div className='row m-0'>
                    <div className='col-12'>
                        <ErrorMessageComponent message={error} />
                    </div>
                </div>
            </div>
            <LoaderComponent loading={loading} />
        </Panel>
    );
};

export default WorkDocumentListComponent;
